var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var IndicatorValueIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 62,
    glyphHeight: 47
  }), React.createElement("path", {
    d: "M17.3913 8.47869C17.3913 13.0909 13.6556 16.8265 9.04347 16.8265C4.4313 16.8265 0.695648 13.0909 0.695648 8.47869C0.695648 3.86651 4.4313 0.130859 9.04347 0.130859C13.6556 0.130859 17.3913 3.86651 17.3913 8.47869ZM9.04347 4.30477C6.74782 4.30477 4.86956 6.18303 4.86956 8.47869C4.86956 10.7743 6.74782 12.6526 9.04347 12.6526C11.3391 12.6526 13.2174 10.7743 13.2174 8.47869C13.2174 6.18303 11.3391 4.30477 9.04347 4.30477Z"
  }), React.createElement("path", {
    d: "M38.2609 16.8262H21.5652V21.0001H38.2609V16.8262Z"
  }), React.createElement("path", {
    d: "M61.2174 4.30469H21.5652V12.6525H61.2174V4.30469Z"
  }), React.createElement("path", {
    d: "M52.8696 25.1738H21.5652V29.3477H52.8696V25.1738Z"
  }), React.createElement("path", {
    d: "M44.5217 33.5215H21.5652V37.6954H44.5217V33.5215Z"
  }), React.createElement("path", {
    d: "M36.1739 41.8691H21.5652V46.0431H36.1739V41.8691Z"
  }));
};
export var IndicatorValueIconGlyph = function (props) {
  return React.createElement(IndicatorValueIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};